var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-radio-group',{attrs:{"defaultValue":_vm.value},on:{"change":_vm.handleChange}},[_vm._l((_vm.scopesMap),function(item){return [(_vm.showScope(item))?_c('a-radio-button',{key:item.key,attrs:{"value":item.key}},[_vm._v(_vm._s(_vm.$t(`policyScopeLabel.${item.key}`)))]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }